import { render, staticRenderFns } from "./EmpChangeEdit.vue?vue&type=template&id=45c49366"
import script from "./EmpChangeEdit.vue?vue&type=script&lang=js"
export * from "./EmpChangeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports